class FacilityReportingGridController {

    constructor(
        $stateParams,
        appConfig
    ) {
        'ngInject';

        this.$stateParams = $stateParams;
        this.appConfig = appConfig;
    }

    $onInit() {
        this.rollupUrl = null;
        this.year = parseInt(this.$stateParams.year);

        this.columns = [
            {
                text: 'Client',
                columnSize: 'lg',
                showSort: true,
                nestedDisplayKeys: ['client', 'name'],
                searchFilterField: 'client'
            },
            {
                text: 'Country',
                columnSize: 'lg',
                showSort: true,
                nestedDisplayKeys: ['country', 'name'],
                searchFilterField: 'country'
            },
            {
                text: 'Campus',
                columnSize: 'lg',
                showSort: true,
                nestedDisplayKeys: ['campus', 'name'],
                searchFilterField: 'campus'
            },
            {
                text: 'Facility',
                columnSize: 'lg',
                showSort: true,
                nestedDisplayKeys: ['facility', 'name'],
                searchFilterField: 'facility'
            },
        ];

        this.breadcrumbs = [
            {
                state: 'app.facility-reporting.client-select',
                displayName: 'Client Select'
            }
        ];

        // Create a list of complete and in-progress months (used to handle the conditionals for the grid squares),
        // and also generate the report url for any months that have complete data.
        this.reportList.map((report) => {
            report.completeMonths = [];
            report.inProgressMonths = [];
            for (let month in report.stats) {
                const stat = report.stats[month];
                if (stat.committed === 1) {
                    report.completeMonths.push(parseInt(month));
                    stat.reportUrl = this.getReportUrl(report, month);
                }
                else if (stat.is_started) {
                    report.inProgressMonths.push(parseInt(month));
                }
            }
        });

    }

    /***
     * Get the MMR report URL for a report on a given month.
     *
     * @param report        an object returned from the MMR Grid endpoint, containing metadata about the report as
     *                      well as its stats data
     * @param month         the numerical value of a month (Jan=1, Feb=2, etc.)
     *
     * @returns {string} URL endpoint for the report
     */
    getReportUrl(report, month) {
        return `${this.appConfig.apiUrl}/report/monthly-engagement/`
                    + `?client=${report.client.id}`
                    + `&country=${report.country.id}`
                    + `&campus=${report.campus.id}`
                    + `&facility=${report.facility.id}`
                    + `&year=${this.year}`
                    + `&month=${month}`
                    + `&mer=${report.stats[month].is_mer_import === 1 ? 1 : 0}`;
    }

    /***
     * Update the rollup report URL with the latest month and facility selections.
     */
    updateRollupUrl(selectedRows, months, year) {
        const facilityIds = selectedRows.map((row) => row.facility.id);

        // Enables multi-month reporting
        if (months.length > 1) {
            this.rollupUrl = `${this.appConfig.apiUrl}/report/single-facility-multi-month/`
                + `?year=${year}`
                + `&months=${months.join(',')}`
                + `&facility=${facilityIds[0]}`;
        }
        else {
            this.rollupUrl = `${this.appConfig.apiUrl}/report/stats-rollup/`
                + `?year=${year}`
                + `&month=${months[0]}`
                + `&facilities=${facilityIds.join(',')}`;
        }

    }
}

export default FacilityReportingGridController;


// WEBPACK FOOTER //
// ./app/components/facility-reporting/facility-reporting-grid/facility-reporting-grid-controller.js